var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row items-center space-x-4 border-2 rounded-lg",class:[
        _vm.type === 'error' ? 'border-r-red text-r-red' : '',
        _vm.type === 'info-green'
            ? 'border-r-green text-r-black bg-r-green-5'
            : '',
        _vm.type === 'success'
            ? 'border-r-green bg-r-green-5 text-r-green'
            : '',
        _vm.padding,
    ]},[(_vm.icon && _vm.hasIcon)?_c('div',{class:_vm.iconClass},[(_vm.icon !== null)?_c('font-awesome-icon',{class:[_vm.type === 'info-green' ? 'text-r-green' : ''],attrs:{"icon":_vm.icon}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-base"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }